import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-holdings-details-dialog',
  templateUrl: './holdings-details-dialog.component.html',
  styleUrls: ['./holdings-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HoldingsDetailsDialog implements OnInit {
  holdDetails: any;
  headers: any;

  constructor(
    public dialogRef: MatDialogRef<HoldingsDetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    if (this.data) {
      this.holdDetails = this.data;
    }
  }

  typeOf(element) {
    const type = 'string';
    if (typeof element == 'object') {
      if (Array.isArray(element)) {
        return 'array';
      } else {
        return 'object';
      }
    }
    return type;
  }
}
